import { useContext } from 'react';

import { GamesContext } from '../context/GamesContext';
import { TranslationsContext } from '../context/TranslationsContext';
import { Badge } from './Badge';
import { LazyImage } from './LazyImage';
import { SizeMap } from './Picture';
import { gameImage } from '../utils/data';

export const Game = ({ game, className = '' }) => {
  const { openGame } = useContext(GamesContext);
  const { locale } = useContext(TranslationsContext);

  const image = gameImage(game, locale)

  return (
    <div
      className={`rounded cursor-pointer ${className}`}
      onClick={() => openGame(game)}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <Badge label={game.label} />
      </div>
      <LazyImage
        className="overflow-hidden rounded shadow-game aspect-h-9 aspect-w-16"
        imageClasses="rounded w-full"
        canvasClasses="rounded"
        hash={image.blurHash}
        alt={game.name}
        imageSizes={image.hor}
        sizeMap={SizeMap.alwaysSmall}
        fallbackSize="sm"
        resolution={2}
      />
    </div>
  );
};
